import { fetchRetry } from './utils';
import { PUBLIC_VOICE_ALIGN_WEBSITE } from '$env/static/public';
import { isAfter } from 'date-fns';
import { AppNotificationSchema, type AppNotification } from '@repo/shared/NotificationServiceTypes';

export type NotificationService = {
	getNotifications: (after: Date, version: string) => Promise<AppNotification[]>;
};

export function createNotificationsService(): NotificationService {
	return {
		async getNotifications(after: Date, version: string) {
			const notifications = await fetchRetry(`${PUBLIC_VOICE_ALIGN_WEBSITE}/api/notifications`, {
				method: 'GET'
			})
				.then((resp) => resp.json())
				.then(AppNotificationSchema.array().parse);
			const filtered = notifications.filter((notification) => {
				return (
					(isAfter(notification.show_after, after) && notification.show_version == 'all') ||
					notification.show_version == version
				);
			});
			return filtered;
		}
	};
}
